import { dateScalarToDate } from './utils';
export function getCurrentFY() {
    return getFY(new Date().valueOf());
}
export function getLastFY() {
    return getCurrentFY() - 1;
}
export function getFY(scalar) {
    const date = dateScalarToDate(scalar);
    return date.getUTCMonth() >= 6 ? date.getUTCFullYear() + 1 : date.getUTCFullYear();
}
export function getCurrentFYStart() {
    return getFYStart(new Date());
}
export function getCurrentFYEnd() {
    return getFYEnd(new Date());
}
export function getFYStart(date) {
    const year = date instanceof Date ? getFY(date.valueOf()) : getFY(date);
    return new Date(Date.UTC(year - 1, 6));
}
export function getFYEnd(date) {
    const year = getFY(date.valueOf());
    return new Date(Date.UTC(year, 5, 30, 23, 59, 59));
}
export function getFYStartForYear(year) {
    return new Date(Date.UTC(year - 1, 6));
}
export function getFYEndForYear(year) {
    return new Date(Date.UTC(year, 5, 30, 23, 59, 59));
}
